var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: { width: _vm.width + "px", height: _vm.myHeight + "px" },
      attrs: { id: "barchart" }
    },
    [
      _c(
        "v-layout",
        {
          attrs: {
            "align-start": "",
            "justify-start": "",
            row: "",
            "fill-height": ""
          }
        },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    "align-start": "",
                    "justify-start": "",
                    column: "",
                    "fill-height": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    [
                      _c("v-tooltip", { attrs: { right: "" } }, [
                        _c("div", {
                          staticClass: "sortButton",
                          attrs: { slot: "activator" },
                          on: {
                            click: function($event) {
                              return _vm.mySort()
                            }
                          },
                          slot: "activator"
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Change sorting")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.sortItems, function(i, index) {
                            return _c("li", { key: "sortItem_" + index }, [
                              i.text === _vm.selectedSortItem
                                ? _c("b", [_c("u", [_vm._v(_vm._s(i.text))])])
                                : _c("span", [_vm._v(_vm._s(i.text))])
                            ])
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("v-tooltip", { attrs: { right: "" } }, [
                        _c("div", {
                          staticClass: "downloadButton",
                          attrs: { slot: "activator" },
                          on: {
                            click: function($event) {
                              return _vm.download()
                            }
                          },
                          slot: "activator"
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Download PNG of bar chart ")])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    "align-start": "",
                    "justify-start": "",
                    column: "",
                    "fill-height": ""
                  }
                },
                [
                  _c("svg", { staticClass: "grouped-bar-chart" }),
                  _vm._v(" "),
                  _c("tooltip", {
                    attrs: {
                      visible: _vm.ttvisible,
                      top: _vm.tttop,
                      left: _vm.ttleft,
                      title: _vm.tttitle,
                      subtitle: _vm.ttsubtitle,
                      value: _vm.ttvalue
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22e0623b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e0623b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BarChart.vue
// module id = null
// module chunks = 